import { render, staticRenderFns } from "./WorkerIdentificationDocument.vue?vue&type=template&id=2cd76627&scoped=true"
import script from "./WorkerIdentificationDocument.vue?vue&type=script&lang=js"
export * from "./WorkerIdentificationDocument.vue?vue&type=script&lang=js"
import style0 from "./WorkerIdentificationDocument.vue?vue&type=style&index=0&id=2cd76627&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd76627",
  null
  
)

export default component.exports